<template>
  <v-expansion-panel>
    <v-expansion-panel-header class="deal-workflow-chain__header">
      <div class="d-flex flex-wrap align-center flex-grow-1 min-width-0">
        <v-chip
          x-small
          outlined
          class="mr-2 deal-workflow-chain__direction"
          :class="`deal-workflow-chain__direction--${chain.direction}`"
        >
          {{ directionLabel }}
        </v-chip>
        <v-chip
          x-small
          class="mr-2"
          :class="`deal-workflow-node__kind-chip--${kindVariant(chain.root.kind)}`"
        >
          {{ kindLabel(chain.root.kind) }}
        </v-chip>
        <router-link
          :to="nodeRoute(chain.root)"
          class="font-weight-medium mr-2"
          @click.native.stop
        >
          {{ chain.root.code }}
        </router-link>
        <v-chip x-small>{{ chain.root.status_label }}</v-chip>

        <template v-if="chain.root.progress">
          <v-progress-linear
            :value="chain.root.progress.percent"
            height="6"
            rounded
            class="deal-workflow-chain__progress ml-2"
            color="primary"
          />
          <span class="text-caption grey--text ml-2">{{ chain.root.progress.percent }}%</span>
        </template>

        <v-chip v-if="chain.root.file_count" x-small outlined class="ml-2">
          {{ chain.root.file_count }} {{ $t("DEALS.VIEW.FILES") }}
        </v-chip>
        <v-chip v-if="childrenCount" x-small class="ml-2">
          {{ childrenCount }} {{ $t("DEALS.VIEW.RELATED") }}
        </v-chip>
      </div>
    </v-expansion-panel-header>

    <v-expansion-panel-content>
      <DealWorkflowNode
        :item="chain.root"
        :show-actions="true"
        :show-progress="false"
        :downloading-file-id="downloadingFileId"
        class="deal-workflow-chain__root mb-3"
        @download-file="$emit('download-file', chain.root, $event)"
        @create-invoice="$emit('create-invoice', chain.root)"
      >
        <template #actions>
          <slot name="node-actions" :item="chain.root" />
        </template>
      </DealWorkflowNode>

      <DealWorkflowTreeBranch
        v-if="chain.root.children && chain.root.children.length"
        class="mt-2"
        :nodes="chain.root.children"
        :depth="1"
        :downloading-file-id="downloadingFileId"
        @download-file="(node, file) => $emit('download-file', node, file)"
        @create-invoice="$emit('create-invoice', $event)"
      >
        <template #node-actions="slotProps">
          <slot name="node-actions" v-bind="slotProps" />
        </template>
      </DealWorkflowTreeBranch>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>

<script>
import DealWorkflowNode from "@/views/pages/deals/partials/DealWorkflowNode.vue";
import DealWorkflowTreeBranch from "@/views/pages/deals/partials/DealWorkflowTreeBranch.vue";
import {
  countTreeNodes,
  kindLabel,
  kindVariant,
  nodeRoute,
} from "@/views/pages/deals/dealWorkflowMeta";

export default {
  name: "DealWorkflowChain",
  components: { DealWorkflowNode, DealWorkflowTreeBranch },
  props: {
    chain: {
      type: Object,
      required: true,
    },
    downloadingFileId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    childrenCount() {
      return countTreeNodes(this.chain.root?.children || []);
    },
    directionLabel() {
      const map = {
        outbound: this.$t("DEALS.VIEW.OUTBOUND"),
        inbound: this.$t("DEALS.VIEW.INBOUND"),
        standalone: this.$t("DEALS.VIEW.STANDALONE_CHAIN"),
      };
      return map[this.chain.direction] || this.chain.direction;
    },
  },
  methods: {
    kindLabel,
    kindVariant,
    nodeRoute,
  },
};
</script>

<style scoped>
.deal-workflow-chain__header {
  min-height: 48px;
}

.deal-workflow-chain__progress {
  max-width: 120px;
  min-width: 80px;
}

.deal-workflow-chain__direction--outbound {
  border-color: #00897b !important;
  color: #00897b !important;
}

.deal-workflow-chain__direction--inbound {
  border-color: #3949ab !important;
  color: #3949ab !important;
}

.deal-workflow-chain__direction--standalone {
  border-color: #757575 !important;
  color: #757575 !important;
}

.deal-workflow-chain__root {
  border: 1px solid #e3e6ef;
  border-radius: 8px;
}
</style>
